<template>
    <div class="stateInventory responsive-menu">
      <div class="responsive-menu__child">
        <PageHeader
          title="Chart Of Account Listing"
          :links="[
            { name: 'home', label: 'Home' },
            { name: 'reports', label: 'Reports' },
            { name: 'financeReport', label: 'Finance' },
            {
              name: 'financeListChartOfAccount',
              label: 'Chart Of Account Listing',
            },
          ]"
          @export="exportToCsv"
          :disableExport="!reportData"
        />
        <br class="no-print" />
        <ReportFilter
          class="no-print"
          @submit-filter="performGetReport"
          :isLoading="financeTransactions"
        />
        <div class="report-container">
          <!-- This could be a component -->
          <div class="report-body" v-if="reportData">
            <table id="table-report">
              <thead>
                <tr class="report-body__row report-body__row--header"></tr>
                <tr>
                  <th align="left">Date</th>
                  <th align="left">Employee</th>
                  <th align="left">DF Account #</th>
                  <th align="left">Account #</th>
                  <th align="left">Name</th>
                  <th align="left">Category</th>
                  <th align="left">Type</th>
                  <th align="left">Can Edit</th>
                </tr>
              </thead>

              <tbody>
                <tr class="report-body__row"></tr>
                <tr v-for="(record, index) in reportData.records" :key="index">
                    <td>{{ record.date }}</td>
                    <td>{{ record.employee }}</td>
                    <td>{{ record.accountNo }}</td>
                    <td>{{ record.accountNoOrganization }}</td>
                    <td>{{ record.name }}</td>
                    <td>{{ record.category }}</td>
                    <td>{{ record.type }}</td>
                    <td>{{ record.canEdit ? 'Y' : 'N' }}</td>
                </tr>
              </tbody>

            </table>
          </div>
        </div>
      </div>
    </div>
  </template>

  <script>
  import PageHeader from "@/components/Header/Header.vue";
  import ReportHelper from "@/lib/report/index.js";
  import { mapActions, mapGetters } from "vuex";
  import ReportFilter from "@/components/ReportFilter/ReportFilter";
  import Utilities from "@/lib/Utilities";

  export default {
    data() {
      return {
        reportData: undefined,
        Utilities,
        reportType: undefined,
        selectedPeriod: undefined,
        selectedReportFor: undefined,
        selectedReportSaleType: undefined,
        filterDropdown: undefined,
      };
    },
    components: {
      PageHeader,
      ReportFilter,
    },
    created: function () {
      this.setPageTitle("Chart Of Account Listing");
    },
    mounted: function () {
      const today = new Date();
      this.selectedPeriod = {
        from: new Date(new Date().setDate(today.getDate() - 7)),
        to: today,
      };
    },
    computed: {
      ...mapGetters({
        loadingStatus: "reports/loadingStatus",
        financeTransactions: "reports/financeTransactions",
      }),
    },
    methods: {
      ...mapActions({
        getFinanceTransactions: "reports/getFinanceTransactions",
      }),
      performGetReport(filter) {
        let reportType = "financeListChartOfAccount";
        this.getFinanceTransactions({
          reportType,
          ...filter,
          positiveCallback: (data) => {
            this.reportData = data;
          },
        });
      },
      exportToCsv() {
        var table = document.getElementById("table-report");
        ReportHelper.exportToExcel(table, "financeListChartOfAccount");
      },
    },
  };
  </script>

  <style lang="scss">
  @import "./_financeListChartOfAccount.scss";